import { types, Instance } from 'mobx-state-tree';
const { model, string, identifier, maybe, maybeNull, number } = types;

export const DepartmentModel = model('DepartmentModel', {
  dn: identifier,
  uid: maybe(string),
  sn: string,
  givenname: maybe(string),
  mail: maybe(string),
  syncDepartment: maybeNull(string),
  userCount: maybeNull(string),
});

export type IDepartmentModel = Instance<typeof DepartmentModel>;

export const ManagerModel = model('ManagerModel', {
  user_id: number,
  secondName: maybe(string),
  firstName: maybe(string),
  email: maybe(string),
});
export type IManagerModel = Instance<typeof ManagerModel>;
